module.exports = __webpack_public_path__ + "img/v6.46bfbcd5.png";